<template>
    <div v-if="false"></div>
</template>

<script>
import MapLibreLayer from '@geoblocks/ol-maplibre-layer'
import TileLayer from 'ol/layer/Tile'
import { TileDebug } from 'ol/source'

export default {
    name: 'MaplibreLayer',
    inject: ['map'],
    created() {
        this.maplibreLayer = new MapLibreLayer({
            name: this.name,
            maplibreOptions: this.options,
        })
        this.map.addLayer(this.maplibreLayer)

        this.debugLayer = new TileLayer({
            source: new TileDebug(),
        })

        //this.map.addLayer(this.debugLayer)
    },
    unmounted() {
        this.map.removeLayer(this.maplibreLayer)
    },
    props: {
        name: String,
        features: Array,
        styleName: String,
        selectable: Boolean,
        options: Object,
    },
}
</script>

<style scoped></style>
